import type { ReactNode } from "react";
import { slugify } from "@/lib/slug";
import { Container } from "./Container";

type SectionProps = {
  title?: string;
  lead?: string;
  children?: ReactNode;
  tone?: "paper" | "surface" | "brand" | "plain";
  className?: string;
};

const toneClasses: Record<NonNullable<SectionProps["tone"]>, string> = {
  paper: "bg-paper",
  surface: "bg-surface border-y border-line",
  brand: "bg-brand-900 text-white",
  plain: "",
};

export function Section({ title, lead, children, tone = "plain", className = "" }: SectionProps) {
  const headingId = title ? slugify(title) : undefined;

  return (
    <section
      className={`py-16 md:py-20 ${toneClasses[tone]} ${className}`.trim()}
      aria-labelledby={headingId}
    >
      <Container>
        {title ? (
          <div className="max-w-3xl">
            <h2 id={headingId} className="text-3xl font-bold md:text-4xl">
              {title}
            </h2>
            {lead ? (
              <p
                className={`mt-4 text-lg leading-relaxed ${tone === "brand" ? "text-brand-100" : "text-ink-soft"}`}
              >
                {lead}
              </p>
            ) : null}
          </div>
        ) : null}
        {children}
      </Container>
    </section>
  );
}
